import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useKubernetesManifestInspectionDiffs() {
    return useBooleanFlagValue("kubernetes-manifest-inspection-diffs-v3", true);
}
